import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Navbar, Nav, NavDropdown, NavLink } from 'react-bootstrap';

const MyNavbar = (props) => {
    const [show, setShow] = useState({ services: false, solutions: false, industries: false });
    
    const showDropdown = (e,click = false) => {
        if(click){
            setShow({...show,e:!show[e]})
            return;
        }else{
            let t = { services: false, solutions: false, industries: false };
            t[e] = !show[e];
            setShow({ ...t });
            return;

        }
    }
    const hideDropdown = (e) => {
        setShow({ services: false, solutions: false, industries: false });
    }
    
    return (
        <>
            <Navbar id="desktopNav" bg="nav" expand="lg" variant="dark" sticky="top" >
                <Navbar.Brand href="/">
                    <img src="/images/logoNew.png" alt={props.brand}/>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <NavDropdown title="Services" id="basic-nav-dropdown"
                            show={show.services}
                            onMouseEnter={() => showDropdown("services")}
                            // onTouchEnd={()=>setShow({...show,services:!show.services})}
                            onMouseLeave={hideDropdown}>
                            {props.links.services.map((service,index) => (
                                <NavDropdown.Item as={Link} to={service.slug} key={index}>{service.name}</NavDropdown.Item>
                            ))}
                        </NavDropdown>
                        <NavDropdown title="Solutions" id="basic-nav-dropdown"
                            show={show.solutions}
                            onMouseEnter={() => showDropdown("solutions")}
                            // onTouchEnd={()=>setShow({...show,solutions:!show.solutions})}
                            onMouseLeave={hideDropdown}>
                            {props.links.solutions.map((solution,index) => (
                                <NavDropdown.Item as={Link} to={solution.slug} key={index}>{solution.name}</NavDropdown.Item>
                            ))}
                        </NavDropdown>
                        <NavDropdown title="Industries" id="basic-nav-dropdown"
                            show={show.industries}
                            onMouseEnter={() => showDropdown("industries")}
                            // onTouchEnd={()=>setShow({...show,industries:!show.industries})}
                            onMouseLeave={hideDropdown}>
                            {props.links.industries.map((industry,index) => (
                                <NavDropdown.Item as={Link} to={industry.slug} key={index}>{industry.name}</NavDropdown.Item>
                            ))}
                        </NavDropdown>
                    </Nav>
                    <Nav className="ms-auto">
                        <NavLink as={Link} to="/our-consultants" className="highlight">Consulting Partners</NavLink>
                    </Nav>

                </Navbar.Collapse>
            </Navbar>
            <Navbar id="mobileNav" bg="nav" expand="lg" variant="dark" sticky="top" >
                <Navbar.Brand href="/">
                    <img src="/images/logoNew.png" alt={props.brand}/>
                    {/* {props.brand} */}
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <NavDropdown title="Services" id="basic-nav-dropdown"
                            show={show.services}
                            // onMouseEnter={() => showDropdown("services")}
                            onClick={()=>setShow({...show,services:!show.services})}
                            onMouseLeave={hideDropdown}
                            >
                            {props.links.services.map((service,index) => (
                                <NavDropdown.Item href={service.slug} key={index}>{service.name}</NavDropdown.Item>
                            ))}
                        </NavDropdown>
                        <NavDropdown title="Solutions" id="basic-nav-dropdown"
                            show={show.solutions}
                            // onMouseEnter={() => showDropdown("solutions")}
                            onClick={()=>setShow({...show,solutions:!show.solutions})}
                            onMouseLeave={hideDropdown}
                            >
                            {props.links.solutions.map((solution,index) => (
                                <NavDropdown.Item href={solution.slug} key={index}>{solution.name}</NavDropdown.Item>
                            ))}
                        </NavDropdown>
                        <NavDropdown title="Industries" id="basic-nav-dropdown"
                            show={show.industries}
                            // onMouseEnter={() => showDropdown("industries")}
                            onClick={()=>setShow({...show,industries:!show.industries})}
                            onMouseLeave={hideDropdown}
                            >
                            {props.links.industries.map((industry,index) => (
                                <NavDropdown.Item href={industry.slug} key={index}>{industry.name}</NavDropdown.Item>
                            ))}
                        </NavDropdown>
                    </Nav>

                    <Nav className="ms-auto">
                        <Nav.Link href="/our-consultants">Consulting Partners</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        </>
    );
}

export default MyNavbar;

